<template>
  <b-container label="Actualizar Datos" v-if="selectedLocationObject">
    <b-row>
      <b-col>
        <b-form-group label="Nombre Sucursal" class="mb-1">
          <b-form-input v-model="selectedLocationObject.name" />
        </b-form-group>
        <b-form-group label="Dirección" class="mb-1">
          <b-form-input v-model="selectedLocationObject.address" />
        </b-form-group>
        <b-form-group label="Región" class="mb-1">
          <b-form-select :options="[{value: '1', text: 'Región 1'}]" v-model="selectedLocationObject.region"/>
        </b-form-group>
        <b-form-group label="Ciudad" class="mb-1">
          <b-form-select :options="[{value: '1', text: 'Ciudad 1'}]" v-model="selectedLocationObject.city"/>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Número de contacto" class="mb-1">
          <b-form-input v-model="selectedLocationObject.contactPhone"/>
        </b-form-group>
        <b-form-group label="Email de contacto" class="mb-1">
          <b-form-input v-model="selectedLocationObject.contactEmail"/>
        </b-form-group>
        <b-form-group label="Google Map" class="mb-1">
          <b-form-input v-model="selectedLocationObject.googleMapUrl"/>
        </b-form-group>
        <b-form-group label="Tipo" class="mb-1">
          <b-form-select :options="[{value:'C2B', text:'C2B'}, {value: 'home', text:'Home'}]" v-model="selectedLocationObject.type"/>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Id Quiter" class="mb-2">
          <b-form-input v-model="selectedLocationObject.quiterId"/>
        </b-form-group>
        <b-form-group label="Activa" class="mb-1">
          <b-form-checkbox v-model="selectedLocationObject.state"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Fecha inicio vigencia" class="mb-1">
          <b-form-datepicker v-model="selectedLocationObject.effectiveStartDate"/>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Fecha término vigencia" class="mb-2">
          <b-form-datepicker v-model="selectedLocationObject.effectiveEndDate"/>
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import {
  BCardBody,
  BFormSelect,
  BFormGroup,
  BRow,
  BCol,
  BContainer,
  BFormInput,
  BFormCheckbox,
  BFormDatepicker,
} from 'bootstrap-vue'

import VueElementLoading from 'vue-element-loading'

export default {
  components: {
    BCardBody,
    BFormSelect,
    VueElementLoading,
    BFormGroup,
    BRow,
    BCol,
    BContainer,
    BFormInput,
    BFormCheckbox,
    BFormDatepicker,
  },
  data() {
    return {
      selectedLocationObject: null,
    }
  },
  watch: {
    selectedLocationObject: {
      handler(newValue){
        this.setLocationForm(newValue)
      },
      deep: true
    }
  },
  computed: {
    ...mapState('locations', ['selectedLocation']),
  },
  methods: {
    ...mapActions('locations', ['getLocationById']),
    ...mapMutations('locations', ['setLocationForm']),
    prepareData(){
      this.selectedLocationObject = this.selectedLocation
    }
  },
  created() {
    this.getLocationById().finally(() => {
      this.prepareData()
    })
    // this.getUserListAction()
  },
}
</script>
